module.exports = {
  controller: [function () {}],
  template: `
    <div class="sid emerald">
        <div class="mt-3" ui-view></div>
    </div>`,
};
